import React, { useState, useEffect } from "react";
import BoxOne from "../../assets/images/boxOne.webp";
import BoxTwo from "../../assets/images/boxTwo.webp";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CustomTitleWihBox = ({ title }) => {
  const direction = useLanguageDirection();

  return (
    <div className="">
      <div className="flex items-center justify-center">
        {/* BoxOne */}
        <img
          src={direction === "rtl" ? BoxOne : BoxTwo}
          alt="box"
          className={`md:h-20 h-16 relative top-[-10px] ${
            direction === "rtl"
              ? "right-[10px] md:right-[20px]"
              : "left-[10px] md:left-[20px]"
          }`}
        />
        {/* Title Section */}
        <div className="bg-custom-yellow text-center inline-block px-4 md:px-8 py-2 min-w-[175px]">
          <h2 className="text-lg font-semibold text-black sm:text-xl lg:text-3xl">
            {title}
          </h2>
        </div>
        {/* BoxTwo */}
        <img
          src={direction === "ltr" ? BoxOne : BoxTwo}
          alt="box"
          className={` md:h-20 h-16 relative  top-[-10px] ${
            direction === "ltr"
              ? "right-[10px] md:right-[20px]"
              : "left-[10px] md:left-[20px]"
          }`}
        />
      </div>
    </div>
  );
};

export default CustomTitleWihBox;
